import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-tooltip',
  templateUrl: 'custom_tool-tip.component.html',
  styleUrls: ['custom_tool-tip.component.scss']
})
export class CustomTooltipComponent {
  @Input()
  toolTipMessage: string;
  @Input()
  placement = 'bottom';
}
